import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-kitdigital',
  templateUrl: './banner-kitdigital.component.html',
  styleUrls: ['./banner-kitdigital.component.scss']
})
export class BannerKitdigitalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
